import {isUserPAYG} from '@Libraries/user.library';
import {assertNever} from '@Utils/assert-never.util';
import type {PublishingOptionDefinition, PublishingOptionHandlers} from '@Components/ai-chat-window/components/publishing-options/publishing-options.types';
import {PublishingOption} from '@Components/ai-chat-window/components/publishing-options/publishing-options.types';

export function getPublishingOptionDefinition(option: PublishingOption, handlers: PublishingOptionHandlers): PublishingOptionDefinition {
  switch (option) {
    case PublishingOption.PUBLISH_TO_SOCIAL_MEDIA:
      return {icon: 'icon-social-media', text: window.i18next.t('pmwjs_post_on_social_media'), hasPremiumCrown: false, publish: handlers.publishToSocialMedia};
    case PublishingOption.PROMOTE_AS_EVENT:
      return {icon: 'icon-event', text: window.i18next.t('pmwjs_turn_into_event_page'), hasPremiumCrown: false, publish: handlers.promoteAsEvent};
    case PublishingOption.PUBLISH_AS_EMAIL_CAMPAIGN:
      return {icon: isUserPAYG() ? 'icon-crown' : 'icon-envelope', text: window.i18next.t('pmwjs_send_as_email'), hasPremiumCrown: isUserPAYG(), publish: handlers.publishAsEmailCampaign};
    default:
      return assertNever(option);
  }
}
